/* @jsx h */

import { cn } from "@lemmonhq/uikit";
import {} from "@lemmonhq/types";
import { defineComponent, h } from "vue";
import { TableVisualProps } from "./types";

export const BarCell = defineComponent<Omit<TableVisualProps, "tableStatus">>({
  name: "BarCell",
  props: ["planConfig", "onFloorPlanCellChange", "tables", "onTableOpen"],
  setup(props) {
    return () => {
      return (
        <div class="relative w-full h-full flex items-center justify-center select-none">
          <div
            class="flex flex-col items-center justify-center gap-0.5 rounded-xl relative overflow-hidden"
            style={{
              width: "100%",
              height: "100%",
              background: "var(--floor-plan-fixture-background)",
              boxShadow: "var(--floor-plan-fixture-shadow)",
              color: "var(--floor-plan-fixture-content)",
            }}
          >
            <span
              class="material-symbols-outlined"
              style="font-size: clamp(1.2rem, 3cqi, 2.5rem); animation: barShake 3s ease-in-out infinite;"
            >
              local_bar
            </span>
            <span style="font-size: clamp(0.5rem, 1.2cqi, 0.65rem); letter-spacing: 0.1em; text-transform: uppercase; opacity: 0.6;">
              Bar
            </span>
            <style>{`
              @keyframes barShake {
                0%, 100% { transform: rotate(0deg) translateY(0); }
                10% { transform: rotate(-12deg) translateY(-2px); }
                20% { transform: rotate(12deg) translateY(-2px); }
                30% { transform: rotate(-8deg) translateY(-1px); }
                40% { transform: rotate(8deg) translateY(-1px); }
                50% { transform: rotate(0deg) translateY(0); }
              }
            `}</style>
          </div>
        </div>
      );
    };
  },
});
